import { motion } from 'motion/react';

interface AnalyzingStateProps {
  modelId: string;
}

/**
 * Estado durante a análise. Não é spinner — é um "scan" lento sobre uma
 * representação simplificada do perfil. Tempo médio 15-40s, então animação
 * precisa parecer trabalho em curso, não loop frívolo.
 */
export function AnalyzingState({ modelId }: AnalyzingStateProps) {
  return (
    <section className="py-12">
      <div className="mb-6">
        <h2 className="font-serif text-2xl font-medium text-[var(--ink-primary)]">
          Analisando seu perfil...
        </h2>
        <p className="mt-2 font-sans text-sm text-[var(--ink-secondary)]">
          {modelId} está lendo cada seção e cruzando com Recruiter Search, algoritmo do feed e ATS.
        </p>
      </div>

      <div className="rounded-md border border-[var(--border-default)] bg-[var(--bg-paper-elevated)] p-6">
        <PageSkeleton />
        <p className="mt-6 font-mono text-xs text-[var(--ink-tertiary)]">
          ~15-40s. Não feche a aba.
        </p>
      </div>
    </section>
  );
}

function PageSkeleton() {
  const lines = [
    { width: '40%', label: 'Nome' },
    { width: '90%', label: 'Headline' },
    { width: '30%', label: 'Localização' },
    { width: 0, label: '' },
    { width: '95%', label: 'Resumo' },
    { width: '88%', label: '' },
    { width: '92%', label: '' },
    { width: '70%', label: '' },
    { width: 0, label: '' },
    { width: '50%', label: 'Experiência 1' },
    { width: '85%', label: '' },
    { width: '40%', label: 'Experiência 2' },
    { width: '83%', label: '' },
  ];

  return (
    <div className="relative">
      <div className="space-y-2">
        {lines.map((l, i) =>
          l.width === 0 ? (
            <div key={i} className="h-2" />
          ) : (
            <div
              key={i}
              className="h-2 rounded-full bg-[var(--ink-muted)] opacity-30"
              style={{ width: l.width }}
            />
          ),
        )}
      </div>

      {/* scanner pass — desce devagar */}
      <motion.div
        className="absolute left-0 right-0 h-[1px] bg-[var(--accent-saffron)]"
        initial={{ top: 0, opacity: 0.4 }}
        animate={{ top: '100%', opacity: 0.8 }}
        transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
}
